export const capitaliseWord = word => String(word).charAt(0).toUpperCase() + String(word).slice(1);
export const capitaliseEveryWord = string => {
    if (typeof string !== 'string') return '';
    const strArr = string.split(' ');
    return strArr.map(word => capitaliseWord(word)).join(' ');
};

export default {
    capitaliseWord,
    capitaliseEveryWord,
};